import type from '../commons/constantActionStatus';

const DEFAULT_STATE = {
  historyConfig: {},
  error: null,
  requestState: false,
  status: null,
  constantCreated: {},
  label:'',
  cities:[]
};

export const constantReducer = (state = DEFAULT_STATE, action) => {
  const actionType = action.type;
  let historyConfig;
  let error = action.error;
  let requestState = action.requestState;
  let status = action.status;
  switch (actionType) {
    // ------get history config constants -------

    case type.GET_HISTORY_CONSTANTS_REQUEST:
      return { ...state, requestState, status };

    case type.GET_HISTORY_CONSTANTS_SUCCESS:
        historyConfig = action.result;
      return {
        ...state,
        historyConfig,
        cities: action.cities,
        requestState,
        status,
      };

    case type.GET_HISTORY_CONSTANTS_FAILURE:
      return { ...state, error, requestState, status };

    case type.CREATE_CONSTANTS_REQUEST:
      return { ...state, requestState, status };

    case type.CREATE_CONSTANTS_SUCCESS:
      return {
        ...state,
        constantCreated: action.result,
        requestState,
        status,
        label:action.label
      };

    case type.CREATE_CONSTANTS_FAILURE:
      return { ...state, error, requestState, status };

    case type.RESET_CONSTANTS_REQUEST:
      return {
        ...state,
        constantCreated: {},
      }

    default:
      return state;
  }
};
